import { render, staticRenderFns } from "./AddJobNote.vue?vue&type=template&id=a4637002&scoped=true"
import script from "./AddJobNote.vue?vue&type=script&lang=ts"
export * from "./AddJobNote.vue?vue&type=script&lang=ts"
import style0 from "./AddJobNote.vue?vue&type=style&index=0&id=a4637002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4637002",
  null
  
)

export default component.exports